import styled from "styled-components";

const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  white-space: nowrap;
  margin-top: 30px;
  border-spacing: 0 10px;
`;
const SubTable = styled.table`
  width: 100%;
  border-collapse: separate;
  white-space: nowrap;
  border-spacing: 0 5px;
`;
const TableHead = styled.thead`
  background-color: #832729;
  border-radius: 8px;
`;
const TableBody = styled.tbody`
  position: relative;
`;
const HeadColumn = styled.th`
  padding: 10px 0 10px 20px;
  text-align: left;
  font-size: 16px;
  font-weight: 500;
  color: white;
`;
const BodyRow = styled.tr`
  padding: 10px 16px;
  cursor: pointer;
`;

const BodyColumn = styled.td`
  font-size: 16px;
  font-weight: 500;
  border-left: none;
  border-right: none;
  border-top: solid 1px #bbbbbb;
  border-bottom: solid 1px #bbbbbb;
  text-align: left;
  vertical-align: middle;
  max-width: 150px;
  text-overflow: ellipsis;
  word-break: break-word;
  white-space: break-spaces;
  padding: 5px 0 5px 20px;

  &:first-child {
    border: solid 1px #bbbbbb;
    border-right: none;
  }
  &:last-child {
    border: solid 1px #bbbbbb;
    border-left: none;
  }
`;

export default {
    Table,
    SubTable,
    TableHead,
    TableBody,
    HeadColumn,
    BodyColumn,
    BodyRow,
}
